import { useState } from "react";
import { useNavigate, useLocation } from "react-router";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toastify";

export default function SetMpin() {
  const [name, setName] = useState("");
  const [mpin, setMpin] = useState("");
  const [confirmMpin, setConfirmMpin] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const phone = localStorage.getItem("phone") || "";
  const mode = location.state?.mode || "register";

  const handleSetMpin = async (e: React.FormEvent) => {
    e.preventDefault();

    const mpinPattern = /^\d{6}$/;
    if (!mpinPattern.test(mpin)) {
      setError("MPIN must be exactly 6 digits");
      return;
    }

    if (mpin !== confirmMpin) {
      setError("MPINs do not match");
      return;
    }

    if (mode === "register" && !name.trim()) {
      setError("Name is required");
      return;
    }

    try {
      await axiosInstance.post("/auth/set-mpin", { phone, mpin, confirmMpin, name }).then((res) => {
        console.log(res.data);
        localStorage.removeItem("phone");
        toast.success("MPIN Set Successfully");
        navigate("/login");
      });
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || "Failed to set MPIN");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-center text-indigo-600 mb-6">
          {mode === "forgot" ? "Reset MPIN" : "Set Your MPIN"}
        </h2>

        <form onSubmit={handleSetMpin} className="space-y-5">
          {mode === "register" && (
            <input
              type="text"
              placeholder="Enter your name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full rounded-xl border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-3"
            />
          )}
          <input
            type="password"
            placeholder="Enter MPIN"
            maxLength={6}
            required
            value={mpin}
            onChange={(e) => setMpin(e.target.value)}
            className="w-full rounded-xl border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-3"
          />
          <input
            type="password"
            placeholder="Confirm MPIN"
            maxLength={6}
            required
            value={confirmMpin}
            onChange={(e) => setConfirmMpin(e.target.value)}
            className="w-full rounded-xl border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 p-3"
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white rounded-xl py-3 font-semibold hover:bg-indigo-700 transition"
          >
            Save MPIN
          </button>
        </form>
      </div>
    </div>
  );
}
